import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient } from '@angular/common/http';
import { IonicModule } from '@ionic/angular';
import { routes } from './app.routes';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { getStorage, provideStorage } from '@angular/fire/storage';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { getRemoteConfig, provideRemoteConfig } from '@angular/fire/remote-config';
import { getFunctions, provideFunctions } from '@angular/fire/functions';
import { initializeAppCheck, provideAppCheck, ReCaptchaV3Provider, ReCaptchaEnterpriseProvider } from '@angular/fire/app-check';
import { provideServiceWorker } from '@angular/service-worker';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimations(),
    importProvidersFrom(IonicModule.forRoot()),
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideFirestore(() => getFirestore()),
    provideStorage(() => getStorage()),
    provideAuth(() => getAuth()),
    provideRemoteConfig(() => getRemoteConfig()),
    provideFunctions(() => getFunctions()),
    // App Check - only enable when site key is configured
    provideAppCheck(() => {
      if (environment.appCheck?.siteKey) {
        // Use Enterprise provider for Enterprise keys, V3 provider for standard keys
        const isEnterprise = environment.appCheck.siteKey.startsWith('6Le_');
        const provider = isEnterprise
          ? new ReCaptchaEnterpriseProvider(environment.appCheck.siteKey)
          : new ReCaptchaV3Provider(environment.appCheck.siteKey);
        return initializeAppCheck(undefined, {
          provider: provider,
          isTokenAutoRefreshEnabled: true
        });
      }
      // Return undefined if no site key (for local dev)
      return undefined as any;
    }),
    provideHttpClient(),
    // Always provide service worker, but only enable when not on localhost
    provideServiceWorker('ngsw-worker.js', {
      enabled: typeof window !== 'undefined' && window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1',
      registrationStrategy: 'registerImmediately'
    })
  ]
};
